import React from "react";
import { apiClient } from "src/api/apiService";
import { FeedProvider, onFetchNextPageProps } from "src/context/Feed";
import { Dashboard } from "src/templates";
import ContentSectionResponsive from "./ContentSection";
import {
  mapTasksToTaskTableRows,
  SortByEnum,
  TaskOverview,
} from "src/components/Tasks";
import { PageTitleSection } from "./PageTitleSection";
import { ActionSection } from "./ActionSection";

export const Tasks: React.FC = () => {
  const handleFetchNextPage = async ({
    searchTerm,
    page,
    sortConfig,
  }: onFetchNextPageProps) => {
    const tasksUrl = "/task/tasks";
    const response = await apiClient.get<{ tasks: TaskOverview[] }>(tasksUrl, {
      params: {
        page,
        limit: 10,
        sortDirection: sortConfig.direction,
        sortBy: sortConfig.key,
        searchTerm: searchTerm?.trim() || undefined,
      },
    });
    return {
      newData: mapTasksToTaskTableRows(response.data.tasks),
      isEOL: response.data.tasks.length === 0,
    };
  };

  return (
    <FeedProvider
      onFetchNextPage={handleFetchNextPage}
      initialState={{
        sortConfig: { key: SortByEnum.TASK_ADDED, direction: "DESC" },
      }}
    >
      <Dashboard
        pageTitleSection={<PageTitleSection />}
        actionSection={<ActionSection />}
        data-id="tasksDashboard"
      >
        <ContentSectionResponsive />
      </Dashboard>
    </FeedProvider>
  );
};
